{
  "name": "Shore",
  "logo": {
    "_1x": "logo1x.png",
    "_2x": "logo2x.png",
    "_3x": "logo3x.png"
  },
  "authLogo": {
    "_1x": "authLogo1x.png",
    "_2x": "authLogo2x.png",
    "_3x": "authLogo3x.png"
  },
  "background": {
    "_1x": "bg1x.png",
    "_2x": "bg2x.png",
    "_3x": "bg3x.png"
  },
  "uiKit": {
    "colors": {
      "theme": {
        "brand": {
          "lightest": "#66A4B3",
          "lighter": "#347F8C",
          "primary": "#006881",
          "darker": "#005367",
          "darkest": "#003E4D"
        },
        "gradient": {
          "login": "linear-gradient(200deg, #006881 0%, #005367 100%)"
        },
        "positive": {
          "main": "#EAAB00",
          "darker": "#C79100",
          "darkest": "#A47800"
        },
        "warning": {
          "main": "#EAAB00"
        }
      }
    },
    "borderRadius": {
      "default": "2px",
      "roundedModal": "4px"
    },
    "typography": {
      "bodyM": {
        "button": {
          "fontFamily": "Source Sans Pro",
          "fontWeight": "700",
          "lineHeight": "16px",
          "fontSize": "14px",
          "letterSpacing": "0.2px",
          "paragraphSpacing": "0px",
          "textCase": "uppercase",
          "textDecoration": "none"
        }
      },
      "bodyL": {
        "buttonL": {
          "fontFamily": "Source Sans Pro",
          "fontWeight": "700",
          "lineHeight": "20px",
          "fontSize": "16px",
          "letterSpacing": "0.2px",
          "paragraphSpacing": "0px",
          "textDecoration": "none",
          "textCase": "uppercase"
        }
      }
    }
  }
}
